var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader__wrapper",style:(_vm.wrapperStyle)},[_c('pulse-loader',{attrs:{"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }